<template>
    <div>
        <!-- <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <img class="swiper_img" src="~@/assets/banner6.png">
                </div>
                <div class="swiper-slide">
                    <img class="swiper_img" src="~@/assets/bg2.jpg">
                </div>
            </div>

            <div class="swiper-pagination"></div>

        </div> -->

        <swiper ref="mySwiper" :options="swiperOptions" v-if="newlist.length != 0">
            <swiper-slide v-for="(vo,i) of newlist" :key="i">
                <img class="swiper_img" :src="$uploadurl + vo.url">
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
        </swiper>

      
    </div>
</template>
      
<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
export default {
  name: 'cswiper',
  components: {
      Swiper,
      SwiperSlide
  },
  directives: {
      swiper: directive
  },
  data () {
    return {
        swiperOptions: {
            loop:true,
            observer:true,
            observeParents:true,
            observeSlideChildren:true,
            autoplay: 5000,
            pagination: ".swiper-pagination",
            prevButton:'.swiper-button-prev',
            nextButton:'.swiper-button-next',
        // Some Swiper option/callback...
        },
        newlist:[]
    }   
  },
  created:function(){
      this.getnews()
  },
  mounted () {
      
  },
  methods:{
      getnews(){
          this.$http.post('/api/index/cbanner').then((res)=>{
              let callback = res.data
              if(callback.code == 200){
                  this.newlist = callback.data
              }else{
                
              }
          }).catch((error) => {
              console.log('获取失败')
          })
      }
  },
}
</script>

<style lang='scss'>
$zycolor:#CF2C2E;
.swiper-slide{
    height: 600px;
    img{
        width: 100%;
        height: 600px;
    }
}
.swiper-pagination-bullet{
  width: 15px;
  height: 15px;
}
.swiper-pagination-bullet-active{
  background: $zycolor;
}
.swiper-button-next{
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: rgba(13, 13, 13, 0.3);
  right: 4%;
  background-image: url('~@/assets/r_right.png');
  background-size:50%;
}
.swiper-button-prev{
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: rgba(13, 13, 13, 0.3);
  left: 4%;
  background-image: url('~@/assets/b_left.png');
  background-size:50%;
}
</style>